import { EMPTY_VALUES_AND_LABELS, useGetChart } from 'charts/common/hooks';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { useCallback, useMemo } from 'react';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { mapValuesAndLabels } from '../model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';

export function useWorkType(): IssueChartContext {
  const processesWithWorkType = useProcessesWithField(
    IssueFieldNames.workTypes
  );
  const access = useCallback(() => {
    return Boolean(processesWithWorkType.length);
  }, [processesWithWorkType]);
  const filters = useIssueChartFilters({ chart: IssueChart.workType, processes: processesWithWorkType });
  const additionalParams = useMemo(
    () => ({ visibleProcesses: processesWithWorkType.map((process) => process._id) }),
    [processesWithWorkType]
  );
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.workType, filters, additionalParams, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.workTypeChart,
    chartType: ChartType.donut,
    canAccess: access,
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
